import { BibleState } from "@/store/modules/bibles/state";

import { BiblesActionTypes } from './action_types'
import { BiblesMutationTypes } from './mutation_types'
import biblesService from '../../../services/bibles.service'


export const actions: StoreActions<BiblesActionTypes, BiblesMutationTypes> = {
  async [BiblesActionTypes.DELETE_BIBLE] (_, { mnemo, bibleId }) {
    return biblesService.deleteBible(mnemo, bibleId)
  },
  async [BiblesActionTypes.EXPORT_BIBLE_TO_IMANAGE] ({ commit, rootState }, { mnemo, bibleId, data }) {
    commit(BiblesMutationTypes.SET_EXPORT_BIBLE_TO_IMANAGE_PENDING, true)
    try {
      await biblesService.exportBibleToImanage(mnemo, bibleId, data, (rootState as any).imanage.authCode?.imConfig)
    } catch (error) {
      commit(BiblesMutationTypes.SET_EXPORT_BIBLE_TO_IMANAGE_ERROR, error)
      throw error
    } finally {
      commit(BiblesMutationTypes.SET_EXPORT_BIBLE_TO_IMANAGE_PENDING, false)
    }
  },
  async [BiblesActionTypes.GET_BIBLE] ({ commit, state }, { mnemo, bibleId }) {
    commit(BiblesMutationTypes.SET_BIBLE_PENDING, bibleId)
    try {
      return await biblesService.getBible(mnemo, bibleId)
    } catch (error) {
      commit(BiblesMutationTypes.SET_BIBLE_ERROR, error)
      throw error
    } finally {
      commit(BiblesMutationTypes.REMOVE_BIBLE_PENDING, (state as BibleState).biblePendingIds.indexOf(bibleId))
    }
  },
  async [BiblesActionTypes.GET_BIBLES] ({ commit }, { mnemo, params, isPolling = false }) {
    if (!params) {
      commit(BiblesMutationTypes.SET_BIBLES_PENDING, true)
    }
    try {
      const data = await biblesService.getBibles(mnemo, params, isPolling)
      if (Array.isArray(data.data)) {
        commit(BiblesMutationTypes.SET_BIBLES, data.data)
      }
    } catch (error) {
      commit(BiblesMutationTypes.SET_BIBLES_ERROR, error)
    } finally {
      commit(BiblesMutationTypes.SET_BIBLES_PENDING, false)
    }
  },
  async [BiblesActionTypes.POST_BIBLE] ({ commit }, { mnemo, data }) {
    commit(BiblesMutationTypes.SET_POST_BIBLE_PENDING, true)
    try {
      const postData = await biblesService.postBible(mnemo, data)
      return postData.data
    } finally {
      commit(BiblesMutationTypes.SET_POST_BIBLE_PENDING, false)
    }
  },
  async [BiblesActionTypes.POST_BIBLE_RIGHTS] (_, { mnemo, bibleId, data }) {
    return biblesService.postBibleRights(mnemo, bibleId, data)
  },
}
